export const DEFAULT_AUDIT_TAB = "audits";

export const AUDIT_MAIN_TABS = ["audits", "findings", "actions", "reports"];

export const AUDIT_SUB_TABS = [
  "survey",
  "files",
  "soa",
  "results",
  "actions",
  "reports",
  "templates",
  "deployments",
];

export function isValidAuditMainTab(tab) {
  return AUDIT_MAIN_TABS.includes(tab);
}

export function isValidAuditSubTab(tab) {
  return AUDIT_SUB_TABS.includes(tab);
}

/**
 * Build a shareable Audit module URL.
 * @param {string} mainTab
 * @param {{ surveyId?: number|string, subTab?: string }} opts
 */
export function auditPath(mainTab = DEFAULT_AUDIT_TAB, { surveyId, subTab } = {}) {
  const safeMain = isValidAuditMainTab(mainTab) ? mainTab : DEFAULT_AUDIT_TAB;

  if (surveyId != null && surveyId !== "") {
    const safeSub = isValidAuditSubTab(subTab) ? subTab : "survey";
    return `/audit/${safeMain}/${surveyId}/${safeSub}`;
  }

  return `/audit/${safeMain}`;
}

/** Parse pathname into Audit navigation state. */
export function parseAuditLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);

  if (parts[0] !== "audit") {
    return { mainTab: DEFAULT_AUDIT_TAB, surveyId: null, subTab: "survey" };
  }

  const mainTab = isValidAuditMainTab(parts[1]) ? parts[1] : DEFAULT_AUDIT_TAB;

  if (parts[2] && parts[3]) {
    return {
      mainTab,
      surveyId: parts[2],
      subTab: isValidAuditSubTab(parts[3]) ? parts[3] : "survey",
    };
  }

  return { mainTab, surveyId: null, subTab: mainTab === "audits" ? "audits" : mainTab };
}

/** Derive activeTab from parsed route (matches existing render conditions). */
export function getAuditActiveTab(parsed) {
  if (parsed.surveyId) return parsed.subTab;
  return parsed.mainTab === "audits" ? "audits" : parsed.mainTab;
}
